// config
import axios from 'axios';

const updateTicketDetail = async ({ id, updateTicketDetailDto }) => {
  const token = 'FgTJfl4Orng6YP3YGqBznJ5DjmgKis';
  const requestConfig = {
    headers: {
      authorization: `Bearer ${token}`,
    },
    data: updateTicketDetailDto,
  };

  return await axios.patch(
    `http://localhost:8000/v1/price-negotiation/tickets/${id}/`,
    requestConfig
  );
};

export default updateTicketDetail;
